<template>
  <g
    v-if="shape"
    ref="group"
    :transform="transformValue"
    class="shape__group"
    :class="{ 'shape__group--selected': isSelected, 'shape__group--no-fill': shape.layoutType == 'scenery', 'shape__group--selectable': selectable }"
    @click="onClick"
  >
    <rect
      ref="shape"
      :id="shape.id"
      v-if="shape && shape.shapeType == 'rect'"
      :x="shape.attributes.x"
      :y="shape.attributes.y"
      :width="shape.attributes.width"
      :height="shape.attributes.height"
      class="shape__element"
      tabindex="0"
    ></rect>
    <image
      ref="shape"
      :id="shape.id"
      v-if="shape && shape.shapeType == 'image' && imageLink"
      :x="shape.attributes.x"
      :y="shape.attributes.y"
      :width="shape.attributes.width"
      :height="shape.attributes.height"
      class="shape__element"
      tabindex="0"
      preserveAspectRatio
      :xlink:href="`data:image/${shape.attributes.mimeType};base64,${imageLink}`"
    ></image>
    <circle
      ref="shape"
      :id="shape.id"
      v-else-if="shape && shape.shapeType == 'circle'"
      :cx="0"
      :cy="0"
      :r="shape.attributes.r"
      class="shape__element"
      tabindex="0"
    ></circle>
    <polygon
      ref="shape"
      :id="shape.id"
      v-else-if="shape && shape.shapeType == 'polygon'"
      :points="pointsString"
      class="shape__element"
      tabindex="0"
    ></polygon>

    <slot></slot>

    <text
        v-if="textValue"
        :x="getShapeCenter.x"
        :y="getShapeCenter.y"
        :transform="textTransformValue"
        dominant-baseline="central"
        alignment-baseline="middle"
        font-size="16"
        font-weight="bold"
        stroke-width="0"
        stroke="#000"
        text-anchor="middle"
        class="shape__text">
        <tspan class="shape__text-span">{{ textValue }}</tspan>
    </text>

    <!-- <foreignObject :x="shapeTopLeft"
        :y="shapeTopLeft" :width="fullWidth" :height="fullHeight">
      <div class="shape__text-container">
        <span class="shape__text">{{ textValue }}</span>
      </div>
    </foreignObject> -->


  </g>
</template>

<script>
export default {
  props: {
    shape: {
      type: Object
    },
    isSelected: {
      type: Boolean
    },
    selectable: {
      type: Boolean,
      default: true
    },
    textValue: {
      type: String
    }
  },
  data() {
    return {
      imageLink: null,
      shapeElement: null,
      groupElement: null
    }
  },
  methods: {
    onClick(event) {
      this.$emit('click', event);
    },
    async getImageLink() {
      const response = await this.axios.get(`/layout/assets/image?id=${this.shape.id}&ext=${this.shape.attributes.ext}`);
      return response.data.image;
    },
  },
  computed: {

    getShapeCenter() {

      let obj = {
        x: 0,
        y: 0
      };

      switch (this.shape.shapeType) {

        case 'rect': 
          obj.x = this.bboxHalfWidth; 
          obj.y = this.bboxHalfHeight;
          break;

        case 'polygon':
          obj.x = this.polygonCenter.x;
          obj.y = this.polygonCenter.y;
          break;

        case 'circle': 
          obj.x = 0;
          obj.y = 0;
          break;

      }

      return obj;

    },

    polygonCenter() {

      if (this.shape.shapeType == 'polygon') {

        let avX = 0;
        let avY = 0;

        let sumX = 0;
        let sumY = 0;

        const pointsAmout = this.shape.attributes.points.length;

        this.shape.attributes.points.forEach((p) => {

          sumX += p.x;
          sumY += p.y;

        });

        avX = sumX / pointsAmout;
        avY = sumY / pointsAmout;

        return {
          x: avX,
          y: avY
        };
    
      } else {
        return null;
      }

    },

    bbox() {
      return this.shapeElement && this.shapeElement.getBBox() || { height: 0, width: 0 };
    },
    bboxHalfHeight() {
      return this.bbox.height / 2;
    },
    bboxHalfWidth() {
      return this.bbox.width / 2;
    },

    textTransformValue() {
      if (this.shape.attributes.transform.rotate.deg != 0) {
        let transform = `rotate(${this.shape.attributes.transform.rotate.deg * -1} ${this.halfWidth} ${this.halfHeight})`;
        return transform;
      }
      else return '';
    },

    transformValue() {
      let transform = `translate(${this.shape.attributes.transform.translate.x} ${this.shape.attributes.transform.translate.y})`;

      if (!['circle', 'polygon'].includes(this.shape.shapeType)) {
        transform += `rotate(${this.shape.attributes.transform.rotate.deg} ${this.halfWidth} ${this.halfHeight})`;
      }

      return transform;
    },
    pointsString() {
      let string = "";
      this.shape.attributes.points.forEach((p) => {
        string += `${p.x},${p.y} `;
      });
      return string;
    },

    shapeTopLeft() {
      if (this.shape.shapeType == 'circle') {
        return this.shape.attributes.r * -1;
      } else if (this.shape.shapeType == 'polygon') {
        if (!this.shapeElement) return 0;
        return this.polygonCenter.x - this.shapeElement.getBBox().height / 2
      } else {
        return 0;
      }
    },

    fullHeight() {
      return this[`getHeight_${this.shape.shapeType}`];
    },
    halfHeight() {
      return this[`getHeight_${this.shape.shapeType}`] / 2;
    },
    fullWidth() {
      return this[`getWidth_${this.shape.shapeType}`];
    },
    halfWidth() {
      return this[`getWidth_${this.shape.shapeType}`] / 2;
    },

    getWidth_rect() {
      return this.shape.attributes.width;
    },
    getHeight_rect() {
      return this.shape.attributes.height;
    },
    getWidth_circle() {
      return this.shape.attributes.r * 2;
    },
    getHeight_circle() {
      return this.shape.attributes.r * 2;
    },
    getWidth_polygon() {
      return this.shapeElement && this.shapeElement.getBBox().width;
    },
    getHeight_polygon() {
      return this.shapeElement && this.shapeElement.getBBox().height;
    },
    getWidth_image() {
      return this.shape.attributes.width;
    },
    getHeight_image() {
      return this.shape.attributes.height;
    },

    hasText() {
      return !!this.$slots.text;
    }
  },
  async created() {
    if (this.shape.shapeType == 'image') {
       this.imageLink = await this.getImageLink();
    }
  },
  mounted() {
    this.shapeElement = this.$refs.shape
    this.groupElement = this.$refs.group
  }
}
</script>

<style lang="scss">
.shape {
  &__text {
    user-select: none; 
    pointer-events: none;
    padding: 2px 5px;
    background: transparentize($white, 0.5);
  }
  &__text-span {
    // background: white;
  }
  &__text-container {
    height: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none; 
    pointer-events: none;
  }
}

.shape {
  &__element {
    fill: #ffffff;
    fill-opacity: 0;
    stroke: #000;
    stroke-width: 2px;
    outline: none !important;
  }
  &__rotate-handle {
    fill: red !important;
    cursor: ew-resize;
  }
  &__resize-handle {
    fill: red !important;
    cursor: grab;
  }
  &__group {
    opacity: 0.5;
    cursor: not-allowed;

    &--selectable {
      cursor: pointer;
      opacity: 1;
    }

    &--selected {
      .shape__element {
        fill: transparentize($--color-primary, 0.5);
        fill-opacity: 1;
        cursor: move !important;
        stroke: $--color-primary;
      }
      &.shape__group--no-fill {
        .shape__element {
          stroke: $--color-primary;
        }
      }
    }
    &--no-fill {
      > * {
        fill: none;
      }
    }
  }
}
</style>
